// generated by bun run generate from the SwiftUI SDK and codegen/catalog.ts.
// edit the generator or catalog, then regenerate.
import type { ViewProps } from 'react-native';
import type { DirectEventHandler, Int32, Double } from 'react-native/Libraries/Types/CodegenTypes';
import codegenNativeComponent from 'react-native/Libraries/Utilities/codegenNativeComponent';
interface NativeProps extends ViewProps {
  onNativeReservedRegionsChange?: DirectEventHandler<Readonly<{
    width: Double;
    height: Double;
    regions: {
      id: string;
      kind: string;
      x: Double;
      y: Double;
      width: Double;
      height: Double;
      marginTop: Double;
      marginLeft: Double;
      marginBottom: Double;
      marginRight: Double;
      isActive: boolean;
    }[];
  }>>;
}
const NativeComponentRegistry = require('react-native/Libraries/NativeComponent/NativeComponentRegistry');
const {
  ConditionallyIgnoredEventHandlers
} = require('react-native/Libraries/NativeComponent/ViewConfigIgnore');
let nativeComponentName = 'OneNativeReservedRegionsProvider';
export const __INTERNAL_VIEW_CONFIG = {
  uiViewClassName: "OneNativeReservedRegionsProvider",
  directEventTypes: {
    topNativeReservedRegionsChange: {
      registrationName: "onNativeReservedRegionsChange"
    }
  },
  validAttributes: {
    ...ConditionallyIgnoredEventHandlers({
      onNativeReservedRegionsChange: true
    })
  }
};
export default NativeComponentRegistry.get(nativeComponentName, () => __INTERNAL_VIEW_CONFIG);